import { NavLink } from 'react-router';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  AlertCircle,
} from '@t90/ui';

export function RegisterPage() {
  return (
    <Card className="animate-fade-in">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 h-16 w-16 rounded-xl bg-t90-navy flex items-center justify-center">
          <span className="text-t90-gold font-bold text-2xl">T90</span>
        </div>
        <CardTitle className="text-2xl">Join Turn90</CardTitle>
        <CardDescription>
          Create your trainee account
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-start gap-3 rounded-md bg-muted p-4">
          <AlertCircle className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-1">Registration by Invitation</p>
            <p>
              Trainee accounts are created by program staff during the enrollment process.
              If you're a new trainee, please contact your program coordinator to get set up.
            </p>
          </div>
        </div>
      </CardContent>
      <CardFooter className="justify-center">
        <p className="text-sm text-muted-foreground">
          Already have an account?{' '}
          <NavLink to="/login" className="text-primary hover:underline">
            Sign in
          </NavLink>
        </p>
      </CardFooter>
    </Card>
  );
}
